export default "__VITE_ASSET__DaP7uVUy__"